import React from 'react';
import { Link } from 'react-router-dom';

function Blog() {
  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#1a1d29', 
      color: '#e2e8f0',
      padding: '40px 20px'
    }}>
      <div className="max-w-4xl mx-auto">
        <h1 style={{ 
          fontSize: '32px', 
          fontWeight: '700', 
          color: '#e2e8f0', 
          marginBottom: '8px',
          textAlign: 'center'
        }}>
          Blog
        </h1>
        
        <p style={{ 
          fontSize: '16px', 
          color: '#9ca3af', 
          textAlign: 'center',
          marginBottom: '40px'
        }}>
          Latest insights and comparisons
        </p>

        <div style={{ 
          backgroundColor: '#242938', 
          border: '1px solid #374151',
          borderRadius: '8px',
          padding: '32px',
          marginBottom: '24px'
        }}>
          <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#e2e8f0', marginBottom: '16px' }}>
            <Link 
              to="/send-10gb-files" 
              style={{ 
                color: '#e2e8f0', 
                textDecoration: 'none',
                transition: 'color 0.2s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#fbbf24'}
              onMouseLeave={(e) => e.target.style.color = '#e2e8f0'}
            >
              How to Send 10GB Files Online - Complete Guide
            </Link>
          </h2>
          
          <p style={{ 
            fontSize: '16px', 
            color: '#d1d5db', 
            marginBottom: '16px',
            lineHeight: '1.6'
          }}>
            Learn how to send large files up to 10GB for free with Largetransfer.net. 
            Step-by-step guide for video sharing, document delivery, and large file transfers.
          </p>
          
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '12px',
            marginBottom: '16px'
          }}>
            <span style={{ 
              fontSize: '14px', 
              color: '#9ca3af',
              backgroundColor: '#374151',
              padding: '4px 8px',
              borderRadius: '4px'
            }}>
              Tutorial
            </span>
            <span style={{ 
              fontSize: '14px', 
              color: '#9ca3af',
              backgroundColor: '#374151',
              padding: '4px 8px',
              borderRadius: '4px'
            }}>
              Large Files
            </span>
            <span style={{ 
              fontSize: '14px', 
              color: '#9ca3af',
              backgroundColor: '#374151',
              padding: '4px 8px',
              borderRadius: '4px'
            }}>
              10GB Upload
            </span>
          </div>
          
          <p style={{ 
            fontSize: '14px', 
            color: '#9ca3af',
            marginBottom: '0'
          }}>
            Published on {new Date().toLocaleDateString()}
          </p>
        </div>

        <div style={{ 
          backgroundColor: '#242938', 
          border: '1px solid #374151',
          borderRadius: '8px',
          padding: '32px',
          marginBottom: '24px'
        }}>
          <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#e2e8f0', marginBottom: '16px' }}>
            <Link 
              to="/wetransfer-alternative" 
              style={{ 
                color: '#e2e8f0', 
                textDecoration: 'none',
                transition: 'color 0.2s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#fbbf24'}
              onMouseLeave={(e) => e.target.style.color = '#e2e8f0'}
            >
              WeTransfer Alternative: Why Largetransfer.net is the Better Choice for File Sharing
            </Link>
          </h2>
          
          <p style={{ 
            fontSize: '16px', 
            color: '#d1d5db', 
            marginBottom: '16px',
            lineHeight: '1.6'
          }}>
            Discover why thousands of users are switching from WeTransfer to Largetransfer.net. 
            Compare features, pricing, and performance in this comprehensive analysis.
          </p>
          
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '12px',
            marginBottom: '16px'
          }}>
            <span style={{ 
              fontSize: '14px', 
              color: '#9ca3af',
              backgroundColor: '#374151',
              padding: '4px 8px',
              borderRadius: '4px'
            }}>
              File Sharing
            </span>
            <span style={{ 
              fontSize: '14px', 
              color: '#9ca3af',
              backgroundColor: '#374151',
              padding: '4px 8px',
              borderRadius: '4px'
            }}>
              Comparison
            </span>
            <span style={{ 
              fontSize: '14px', 
              color: '#9ca3af',
              backgroundColor: '#374151',
              padding: '4px 8px',
              borderRadius: '4px'
            }}>
              WeTransfer Alternative
            </span>
          </div>
          
          <p style={{ 
            fontSize: '14px', 
            color: '#9ca3af',
            marginBottom: '0'
          }}>
            Published on {new Date().toLocaleDateString()}
          </p>
        </div>

        <div style={{ 
          backgroundColor: '#242938', 
          border: '1px solid #374151',
          borderRadius: '8px',
          padding: '32px',
          marginBottom: '24px'
        }}>
          <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#e2e8f0', marginBottom: '16px' }}>
            <Link 
              to="/" 
              style={{ 
                color: '#e2e8f0', 
                textDecoration: 'none',
                transition: 'color 0.2s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#fbbf24'}
              onMouseLeave={(e) => e.target.style.color = '#e2e8f0'}
            >
              ← Back to Home
            </Link>
          </h2>
        </div>
      </div>
    </div>
  );
}

export default Blog;
